import React from 'react';

import withModal from '../../../global/modal/withModal';
import VideoDownload from './VideoDownload';

export const VIDEO_DOWNLOAD_LINKS_MODAL = 'modal/VIDEO_DOWNLOAD_LINKS';

const VideoDownloadModal = ({ actionProps: { video }, ...props }) => {
  return <VideoDownload video={video} {...props} />;
};

export default withModal(VideoDownloadModal, {
  name: VIDEO_DOWNLOAD_LINKS_MODAL,
  contentLabel: 'Video Download',
  size: 'sm',
});
